import React from "react";

export default function PlusIcon() {
  return (
    <svg
      data-testid="plus-icon"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Plus">
        <path
          data-testid="plus-icon-path"
          id="Vector"
          d="M12 5V19M5 12H19"
          stroke="#306582"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
